import React, {forwardRef} from 'react';
import {useTranslation} from 'react-i18next';
import {AiAssistantConversation, Role} from './types';
import {ConditionalRender} from '../../common/conditional-render/ConditionalRender';
import {ChatMessage} from './chatMessage';
import {ChatSuggestions} from './chatSuggestions';

export type ChatWindowProps = {
    conversation: AiAssistantConversation | undefined;
    streamedAnswer?: string;
    isGeneratingAnswer?: boolean;
    suggestionsEnabled?: boolean;
    updateConversationForSuggestions?: (v: string) => Promise<void>;
    renderSources?: boolean;
};
export const ChatWindow = forwardRef<HTMLDivElement, ChatWindowProps>(function ChatWindow({
    conversation,
    streamedAnswer = '',
    isGeneratingAnswer = false,
    suggestionsEnabled,
    updateConversationForSuggestions,
    renderSources,
}, ref): React.JSX.Element | null {
    const {t} = useTranslation();
    if (!conversation) {
        return null;
    }

    return (
        <div className="chat-window-container">
            <div className="chat-window" ref={ref}>
                {conversation.conversationMessages.map((msg, index) => (
                    <ConditionalRender
                        key={'chat-message-' + index}
                        shouldRender={!!msg.text}
                        children={<ChatMessage msg={msg} index={index} shouldRenderSources={renderSources}/>}
                    />
                ))}
                {isGeneratingAnswer && (
                    <ChatMessage
                        index={999}
                        msg={{text: streamedAnswer || t('assistant.generating-answer'), role: Role.ASSISTANT}}
                        hideActions={true}
                        isPlaceholder={!streamedAnswer}
                    />
                )}
                <ConditionalRender
                    shouldRender={!!suggestionsEnabled && !!updateConversationForSuggestions}
                    children={
                        <ChatSuggestions
                            suggestions={conversation.suggestions}
                            updateConversation={updateConversationForSuggestions}
                        />
                    }
                />
            </div>
        </div>
    );
});
